<template>
  <div class="d2dreview-page">
    <div class="rv-title">Secure booking - only takes a few minutes!</div>

    <div class="d-flex rv-page-body align-start">
      <div class="rv-form">
        <pax-form ref="paxForm" @done="paxDone" @getCardsDone="getCardsDone" class="pax-form-box"></pax-form>
        <payment-form v-if="user.token || bookingAsGuest" ref="paymentForm"
          @done="paymentDone" @changeCard="changeCard"
          class="payment-form-box"
        ></payment-form>

        <div class="submit-box" v-if="user.token || bookingAsGuest">
          <div class="sb-header">Review and book your trip</div>
          <!-- <div class="sb-subheader">
            <i class="fas fa-check"></i>
            Free cancellation within <a>24 hours of booking!</a>
          </div> -->
          <div class="sb-text">1 . Review your trip details to make sure the dates and times are correct.</div>
          <div class="sb-text">2. Check your spelling. Flight passenger names must match government-issued photo ID exactly.</div>
          <div class="sb-text">3. Review the terms of your booking:</div>
          <ul>
            <li>
              If you book a fare that allows changes, the airline may charge a change or cancel fee, plus any 
              fare difference. Airlines set change and cancel policies and fee amounts. We may collect these 
              change or cancel fees, which are then passed on to the airline.
            </li>
            <li>
              Your itinerary consists of two one-way fares which are subject to their own rules and restrictions. 
              If one of your flights is changed or cancelled, it will not automatically change the other flight. 
              You may incur a penalty fee for each flight for additional itinerary changes.
            </li>
            <li>
              In case of a no-show or cancellation, you may be entitled to a refund of airport taxes and fees 
              included in the price
            </li>
          </ul>
          <!-- <div class="sb-text">
            By clicking on the button below, I acknowledge that I have reviewed the 
            <a>Privacy Statement <i class="fas fa-external-link-alt"></i></a> and 
            <a>Government Travel Advice <i class="fas fa-external-link-alt"></i></a> and 
            have reviewed and accept the above Rules & Restrictions and
            <a>Terms of Use <i class="fas fa-external-link-alt"></i></a>.
          </div> -->
          <!-- <div class="lr-btn complete-btn" @click="validateForms">
            Compete Booking
            <i class="fas fa-chevron-right"></i>
          </div> -->
          <!-- <div class="d-flex sb-foot align-start">
            <i class="fas fa-lock"></i>
            <div>
              <div class="sb-text">We use secure transmission and encrypted storage to protect your personal information.</div>
              <div class="sb-text">
                Payments are processed in the U.S. except where the travel provider (hotel / airline etc) 
                processes your payment outside the U.S., in which case your card issuer may charge a foreign 
                transaction fee.
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <div class="ps-box">
        <payment-summary ref="paymentSummary" :notop="true"/>
        <div :class="['lr-btn complete-btn', {highlight:card > 0}]" @click="validateForms">
          Confirm Booking
          <i class="fas fa-chevron-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import paxForm from './PaxForm'
import paymentForm from './PaymentForm'
import paymentSummary from '@/components/D2DOthers/PaymentSummary'

export default {
  name: 'review-page',
  components: { paxForm, paymentForm, paymentSummary },
  data () {
    return {
      valid: {
        pax: false,
        payment: false
      },
      card: ''
    }
  },
  computed: {
    user () { return this.$store.state.user },
    booking () { return this.$store.state.booking },
    locations () { return this.booking.locations },
    bookingAsGuest () { return this.booking.bookAsGuest },
    other () { return this.$store.state.other },
    logoutStore () { return this.$store.state.global.logout }
  },
  methods: {
    validateForms () {
      if (!this.user.token && !this.bookingAsGuest) return
      this.valid = {pax: false, payment: false}
      if (this.$refs.paxForm) this.$refs.paxForm.submitPax()
    },
    paxDone (r) {
      this.valid.pax = r
      if (this.$refs.paymentForm) this.$refs.paymentForm.submitForm()
    },
    paymentDone (r) {
      this.valid.payment = r

      if (this.valid.pax && this.valid.payment) {
        if (this.$refs.paymentSummary) this.$refs.paymentSummary.initBook(false)
        return
      }
      if (!this.valid.pax) document.querySelector('.pax-form-box').scrollIntoView()
      else if (!this.valid.payment) document.querySelector('.payment-form-box').scrollIntoView()
    },
    getCardsDone () {
      if (this.$refs.paymentForm) this.$refs.paymentForm.checkCardsIfAvail()
    },
    changeCard (x) {
      this.card = x
    }
  },
  watch: {
    'logoutStore.success': function (val) {
      if (val) {
        if (this.$refs.paymentForm) this.$refs.paymentForm.clearStripeForm()
      }
    }
  },
  mounted () {
    if (
      (!Object.keys(this.locations.pickupAirport).length && this.other.widgetTab === 'd2d') ||
      (this.locations.flight.pickup.title === '' && this.other.widgetTab === 'flight')
    ) {
      this.$root.$router.push('search')
      return
    }
    document.querySelector('.d2dreview-page').scrollIntoView()
  }

}
</script>

<style lang="scss" scoped>
.d2dreview-page{
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;
  padding-top: 20px;
}
.rv-title{
  font-size: 25px;
  font-weight: 600;
  margin-bottom: 30px;
  line-height: 1;
  letter-spacing: .6px;
}
.rv-page-body{
  gap: 20px;
}
.rv-form{
  width: calc(100% - 400px);
}
.submit-box{
  border: 1px solid #abb2b8;
  border-radius: 6px;
  padding: 30px;
  background: #fff;
  margin-bottom: 30px;
  letter-spacing: .5px;

  a{
    color: #1568e3!important;

    i{
      margin-left: 6px;
    }
  }
}
.sb-header{
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 25px;
  color: #333;
}
.sb-subheader{
  color: #333;
  margin-bottom: 15px;
  font-size: 14px;
  i{
    color: #307000;
    margin-right: 6px;
  }
}
.sb-text{
  color: #636363;
  font-size: 14px;
  margin-bottom: 8px;
}
ul{
  font-size: 14px;
  line-height: 1.5;
  color: #636363;

  li{
    margin-bottom: 10px;
  }
}
.complete-btn{
  font-size: 18px;
  padding: 16px 40px;
  // margin: 30px 0;
  // display: inline-block;

  i{
    margin-left: 10px;
    vertical-align: -2px;
  }
  &.highlight{
    opacity: 1;
    animation: glow .5s infinite alternate;
  }
}
@keyframes glow {
  from { box-shadow: 0 0 2px -2px #f8cf71; }
  to { box-shadow: 0 0 2px 2px #efbb43; }
}
.sb-foot{
  gap: 15px;
  color: #8f8f8f;
  margin-top: 50px;

  .sb-text{
    color: #8f8f8f;
    font-style: italic;
    font-size: 13px;
  }
}
.ps-box{
  width: 400px;
}

@media only screen and (max-width: 639px) {
  .rv-page-body{
    flex-direction: column-reverse;
  }
  .rv-form,
  .ps-box{
    width: 100%;
  }
  .complete-btn{
    display: block;
  }
}
</style>


// WEBPACK FOOTER //
// index.vue?c4d54dac